import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import API from '../api/axios';
import toast from 'react-hot-toast';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(localStorage.getItem('zabtat_token'));

  // تحميل بيانات المستخدم عند بدء التطبيق
  useEffect(() => {
    const initAuth = async () => {
      const savedToken = localStorage.getItem('zabtat_token');
      if (savedToken) {
        try {
          const { data } = await API.get('/auth/me');
          setUser(data.user);
        } catch {
          localStorage.removeItem('zabtat_token');
          localStorage.removeItem('zabtat_user');
          setToken(null);
        }
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  // تسجيل الدخول
  const login = useCallback(async (email, password) => {
    const { data } = await API.post('/auth/login', { email, password });
    localStorage.setItem('zabtat_token', data.token);
    setToken(data.token);
    setUser(data.user);
    return data;
  }, []);

  // التسجيل
  const register = useCallback(async (formData) => {
    const { data } = await API.post('/auth/register', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    localStorage.setItem('zabtat_token', data.token);
    setToken(data.token);
    setUser(data.user);
    return data;
  }, []);

  // تسجيل الخروج
  const logout = useCallback(() => {
    localStorage.removeItem('zabtat_token');
    localStorage.removeItem('zabtat_user');
    setToken(null);
    setUser(null);
    toast.success('تم تسجيل الخروج');
  }, []);

  const forgotPassword = useCallback(async (email) => {
    return await API.post('/auth/forgot-password', { email });
  }, []);

  const resetPassword = useCallback(async (token, password, confirmPassword) => {
    return await API.post(`/auth/reset-password/${token}`, { password, confirmPassword });
  }, []);

  // تحديث بيانات المستخدم
  const refreshUser = useCallback(async () => {
    try {
      const { data } = await API.get('/auth/me');
      setUser(data.user);
    } catch (err) {
      console.error(err);
    }
  }, []);

  const value = {
    user,
    token,
    loading,
    isLoggedIn: !!token && !!user,
    login,
    register,
    logout,
    refreshUser,
    setUser,
    forgotPassword,
    resetPassword,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
};
